/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_User_Api_Keys_TitleInputs */

const es_walkthrough_user_api_keys_title = /** @type {(inputs: Walkthrough_User_Api_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clave API`)
};

const en_walkthrough_user_api_keys_title = /** @type {(inputs: Walkthrough_User_Api_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key`)
};

/**
* | output |
* | --- |
* | "API Key" |
*
* @param {Walkthrough_User_Api_Keys_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_user_api_keys_title = /** @type {((inputs?: Walkthrough_User_Api_Keys_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_User_Api_Keys_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_user_api_keys_title(inputs)
	return en_walkthrough_user_api_keys_title(inputs)
});
export { walkthrough_user_api_keys_title as "walkthrough.user_api_keys_title" }